import Fade from '@mui/material/Fade';

type Params = {
    children: JSX.Element;
}

const ContentFadeAnimation = ({ children }: Params) => {
    return (
        <Fade in={true} {...(true ? { timeout: 500 } : {})}>
            {children}
        </Fade>
    );
}

export default ContentFadeAnimation;